import React, {useEffect} from "react";
import { useLocation } from 'react-router-dom'
import LandingPage from "../../components/LandingPage/LandingPage";

import "../../App.css";

const HomePage = () => {

  const location = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo(0, 0);
    }, 0);
  
    return () => {
      clearTimeout(timeout);
    };
  }, [location]);


  return (
    <div className="App">
      <LandingPage />
    </div>
  );
}

export default HomePage;
